import { useContext } from "react";

import { $ok } from "foundation-ts/commons";

import { AuthContext } from "@/contexts/AuthContext";

export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!$ok(context)) { throw new Error("Unable to useAuthContext out AuthProvider"); }

    return context!;
}